<template>
  <div>
    <h3>Chart</h3>
    <div :class="$style.switchWrapper">
    <!-- <SwitchCmChart /> -->
      <div :class="$style.root">
    <div
      :class="[$style.button, { [$style.active]: !isCmChart }]"
      @click="setIsCmChartA(false)"
    >IN</div>
    <div
      :class="[$style.button, { [$style.active]: isCmChart }]"
      @click="setIsCmChartA(true)"
    >CM</div>
  </div>
  </div>

    <!-- <button type="button" onclick="convertToCm()">Convert to Inches</button> -->
    <div :class="$style.tableContainer" ref="table" />
  </div>
</template>

<script>
// import { mapState} from 'vuex';
// import SwitchCmChart from '@/components/lib/SwitchCmChart'
export default {
    
// computed: mapState(['isCmChart']),
/*   components: {
    SwitchCmChart,

  },   */
  data(){
      return{
          isCmChart:false
      }
  },
  methods:{
    setIsCmChartA(data){
        const tableElement = document.getElementById("ChartNameByUser");
        const tableClassName = tableElement.className;
        console.log("setIsCmChart Before", this.isCmChart)
        const previousCMValue = this.isCmChart;
        // this.isCmChart = data;
        console.log("setIsCmChart", this.isCmChart)
        if(data && !previousCMValue){
            if(tableClassName === "vdr-cm"){
                this.isCmChart = data;
                const oldData = this.$refs.table.children[0]
                const newData = document.getElementById('VitruvianChart').cloneNode(true)
                newData.setAttribute("id", 'VitruvianChartWidget')
                newData.style.setProperty('display', 'block')
                this.$refs.table.replaceChild(newData, oldData)
            }
            else{
            this.convertToCm();
            this.isCmChart = data;
            }
        }
        else if(!data && previousCMValue){
            if(tableClassName === "vdr-in"){
                this.isCmChart = data;
                const oldData = this.$refs.table.children[0]
                const newData = document.getElementById('VitruvianChart').cloneNode(true)
                newData.setAttribute("id", 'VitruvianChartWidget')
                newData.style.setProperty('display', 'block')
                this.$refs.table.replaceChild(newData, oldData)
            }
            else{
            this.convertToIn();
            this.isCmChart = data;
            }
        }
    }, 
    convertToCm() {
        //if class name of children 1 === scrollable-wrapper
        var oldTable = ""
        const classOfFirstGrandChild = this.$refs.table.children[0].children[1].className;
        console.log("classOfFirstGrandChild: ", classOfFirstGrandChild)
        if(classOfFirstGrandChild === "vdr-in" || classOfFirstGrandChild === "vdr-cm" ){
          oldTable = this.$refs.table.children[0].children[1]
          console.log("in if")
        }

        else{
          oldTable = this.$refs.table.children[0].children[1].children[0]
          console.log("in else")
        }

        console.log("Converting")
        var oTable = oldTable;

        var colLength = oTable.rows[0].cells.length;
        var rowLength = oTable.rows.length;
      

        for (var i = 1; i < rowLength; i++) {
            // sizeName = oTable.cols.item(1).cells;

            for(var c = 1; c < colLength; c++){
                var range = oTable.rows[i].cells[c].innerHTML;
                var split = range.split("-");
                
                if (split.length === 1) {
                var cellInput = Number(split[0]);
                const newCellInput = (2.54*cellInput).toFixed(1);

                oTable.rows[i].cells[c].innerHTML =newCellInput;
                } else if (split.length === 2) {
                var firstCellInput = Number(split[0]);
                var secondCellInput = Number(split[1]);
                const newFirstCellInput = (2.54*firstCellInput).toFixed(1);
                const newSecondCellInput = (2.54*secondCellInput).toFixed(1);
                const newCellInput = newFirstCellInput + "-" + newSecondCellInput;
                oTable.rows[i].cells[c].innerHTML = newCellInput;
                }

            }


        }

        if(classOfFirstGrandChild === "vdr-in" || classOfFirstGrandChild === "vdr-cm" ){
          this.$refs.table.children[0].replaceChild(oTable, oldTable)
          console.log("in if")
        }
        else{
          this.$refs.table.children[0].children[1].replaceChild(oTable, oldTable)
          console.log("in else")
        }


    },
        convertToIn() {
        var oldTable = ""
        const classOfFirstGrandChild = this.$refs.table.children[0].children[1].className;
        if(classOfFirstGrandChild === "vdr-in" || classOfFirstGrandChild === "vdr-cm" ){
          oldTable = this.$refs.table.children[0].children[1]
        }

        else{
          oldTable = this.$refs.table.children[0].children[1].children[0]
          console.log("in else")
        }

        var oTable = oldTable;


        var colLength = oTable.rows[0].cells.length;
        var rowLength = oTable.rows.length;
   

        for (var i = 1; i < rowLength; i++) {
            // sizeName = oTable.cols.item(1).cells;

            for(var c = 1; c < colLength; c++){
                var range = oTable.rows[i].cells[c].innerHTML;
                var split = range.split("-");
                
                if (split.length === 1) {
                var cellInput = Number(split[0]);
                const newCellInput = (cellInput/2.54).toFixed(1);

                oTable.rows[i].cells[c].innerHTML =newCellInput;
                } else if (split.length === 2) {
                var firstCellInput = Number(split[0]);
                var secondCellInput = Number(split[1]);
                const newFirstCellInput = (firstCellInput/2.54).toFixed(1);
                const newSecondCellInput = (secondCellInput/2.54).toFixed(1);
                const newCellInput = newFirstCellInput + "-" + newSecondCellInput;
                oTable.rows[i].cells[c].innerHTML = newCellInput;
                }

            }


        }


        if(classOfFirstGrandChild === "vdr-in" || classOfFirstGrandChild === "vdr-cm" ){
          this.$refs.table.children[0].replaceChild(oTable, oldTable)

        }

        else{
          this.$refs.table.children[0].children[1].replaceChild(oTable, oldTable)
        }

    },
  },
  mounted() {
    const table = document.getElementById('VitruvianChart').cloneNode(true)
    table.setAttribute("id", 'VitruvianChartWidget')
    table.style.setProperty('display', 'block')
    const tableElement = document.getElementById("ChartNameByUser");
    const tableClassName = tableElement.className;
    if(tableClassName === 'vdr-in'){
        this.isCmChart = false;
    }
    else{
       this.isCmChart = true; 
    }
    console.log("tableClass: ", tableClassName)
    this.$refs.table.appendChild(table)
  },
}
</script>

<style lang="scss" module>
.tableContainer {
  overflow: auto;

  & table, & td, & th {
    border: 1px solid #000;
    border-spacing: 0;
    border-collapse: collapse;
  }

}

.footerButton {
  display: inline-block;
  cursor: pointer;
  color: rgb(84, 155, 212);
  margin-left: 20px;
  transition: .2s;
  &:hover { color: rgb(40, 96, 143); }
}

.switchWrapper {
  padding-bottom: 10px;
}

.root {
  display: inline-flex;
  margin: auto;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 10px;
}

.button {
  display: block;
  width: 50%;
  border-radius: 10px;
  padding: 5px 15px;
  color: #333;
  cursor: pointer;
}

.active {
  color: #fff;
  background-color: rgb(0, 0, 0);
}
</style>
